import styled, { keyframes } from 'styled-components';

const LoaderContainer = styled.div`
  position: relative;
  ${(props) => props.$style}
`;

const animate = keyframes`

    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
  }`;

const LoaderStyled = styled.span`
  width: 15px;
  height: 15px;
  border: 2px solid var(--darkGrey);
  border-radius: 50%;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  animation: ${animate} 0.7s linear infinite;
  background-color: var(--blue);

  &::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 2px solid transparent;
    border-bottom-color: var(--red);
    border-left-color: var(--red);
  }
`;

const Loader = ({ $visible = false, style }) =>
  $visible && (
    <LoaderContainer $style={style}>
      <LoaderStyled />
    </LoaderContainer>
  );

export default Loader;
